<template>
  <v-container v-if="carrinho.length > 0">
    <v-row class="white mx-1">
      <v-col class="d-flex align-center justify-center mt-4">
        <p
          class="text-center font-weight-bold title grey--text text--darken-2 mb-0"
        >
          Finalizar pedido
        </p>
      </v-col>

      <v-col cols="12">
        <v-row no-gutters>
          <v-col lg="12">
            <p
              class="text-left font-weight-regular body-2 grey--text text--darken-2 mb-0"
            >
              Resumo do pedido
            </p>
            <div>
              <v-expansion-panels
                hover
                flat
                style="border-bottom: 1px solid var(--vs-marrom-secundario) !important;"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    class="grey--text text--darken-2 pa-0"
                  >
                    <v-col lg="9" md="6" sm="6" class="pa-0 pl-4"
                      >Ver todos os produtos</v-col
                    >

                    <v-col
                      lg="1"
                      md="2"
                      sm="2"
                      class="pa-0 pl-4 text-right caption"
                      >Qtd</v-col
                    >
                    <v-col
                      lg="2"
                      md="4"
                      sm="4"
                      class="pa-0 pr-2 text-right font-weight-bold"
                      v-if="
                        valorFrete === retornoValorFreteNull ||
                          valorFrete === true
                      "
                      >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</v-col
                    >

                    <v-col
                      lg="2"
                      md="4"
                      sm="4"
                      class="pa-0 pr-2 text-right font-weight-bold"
                      v-else
                      >{{ parseFloat(totalPedidoSemFrete).toFixed(2).replace('.', ',') | currency }}</v-col
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card v-for="(c, i) in carrinho" :key="i" elevation="0">
                      <v-row no-gutters class="d-flex">
                        <v-col lg="9">
                          <div class="text-left caption font-weight-regular">
                            {{ c.anuncio.fitStrNme }}
                          </div>
                        </v-col>
                        <v-col lg="1" class="justify-end">
                          <div class="text-right caption font-weight-regular">
                            {{ c.carIntQtd }}
                          </div>
                        </v-col>
                        <v-col lg="2" class="d-flex justify-end">
                          <div class="float-right algin-end">
                            <span class="text-right caption font-weight-bold">
                              {{
                                parseFloat((c.anuncio.ancFltPrecoVendaDesconto *
                                  c.carIntQtd)).toFixed(2).replace('.', ',')
                                  | currency
                              }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-col>

          <v-row no-gutters class="d-flex align-start justify-center pa-0">
            <v-col lg="4" md="12" sm="12" class="pl-7 pt-4">
              <p
                class="text-left font-weight-bold body-2 grey--text text--darken-2 mb-0"
              >
                Dados da empresa
              </p>
              <span
                class="d-flex font-weight-light grey--text text--darken-2 body-2"
                >{{ usuarioLogado.cliente.cliStrNme }}</span
              >
              <span
                class="d-flex font-weight-light grey--text text--darken-2 body-2"
                >{{ usuarioLogado.cliente.cliStrDocumento | documento }}</span
              >

              <span
                class="d-flex font-weight-light grey--text text--darken-2 body-2"
                >{{ usuarioLogado.busChaFone1 }}</span
              >
            </v-col>

            <v-col lg="4" md="12" sm="12" class="pl-7 pt-4">
              <p
                class="text-left font-weight-bold body-2 grey--text text--darken-2 mb-0"
              >
                Endereço
              </p>

              <span
                class="d-flex font-weight-light grey--text text--darken-2 body-2"
              >
                {{ usuarioLogado.busStrEndereco }} -
                {{ usuarioLogado.busStrBairro }}
              </span>
              <span
                class="d-flex font-weight-light grey--text text--darken-2 body-2"
              >
                {{ usuarioLogado.busStrCidade }} -
                {{ usuarioLogado.busChaUf }}
              </span>
              <span
                class="d-flex font-weight-light grey--text text--darken-2 body-2"
                >{{ usuarioLogado.busChaCep }}</span
              >

              <v-dialog v-model="dialogEndereco" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                  <vs-button
                    style="min-width: 70px"
                    color="primary"
                    class="float-left ml-0"
                    animation-type="scale"
                    v-on="on"
                  >
                    <i
                      class="las la-check pr-2"
                      style="font-size: 16px !important"
                    ></i>
                    <template>Editar</template>
                  </vs-button>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Editar endereço</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            label="CEP"
                            v-model="usuarioLogado.busChaCep"
                            type="text"
                            v-mask="mask.cep"
                            @input="procurarCEP()"
                            required
                            color="var(--vs-azul-secundaria)"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="10" md="12" class="pr-3">
                          <v-text-field
                            label="Endereço"
                            v-model="usuarioLogado.busStrEndereco"
                            type="text"
                            required
                            color="var(--vs-azul-secundaria)"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="4" md="12" class="pr-3">
                          <v-text-field
                            label="Bairro"
                            v-model="usuarioLogado.busStrBairro"
                            type="text"
                            required
                            color="var(--vs-azul-secundaria)"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="4" md="12" class="pr-3">
                          <v-text-field
                            label="Cidade"
                            v-model="usuarioLogado.busStrCidade"
                            type="text"
                            required
                            color="var(--vs-azul-secundaria)"
                          ></v-text-field>
                        </v-col>
                        <v-col lg="4" md="12" class="pr-3">
                          <v-text-field
                            label="UF"
                            v-model="usuarioLogado.busChaUf"
                            type="text"
                            required
                            color="var(--vs-azul-secundaria)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="var(--vs-azul-secundaria)"
                      text
                      @click="dialogEndereco = false"
                      >Fechar</v-btn
                    >
                    <v-btn
                      color="var(--vs-azul-primaria)"
                      text
                      @click="editarEndereco(user)"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col lg="4" md="12" sm="12" class="pl-7 pt-4">
              <OpcaoEntega />

              <CalcFrete v-if="tipoEntrega === 'FRT'" />
            </v-col>
          </v-row>
        </v-row>
        <v-col cols="12">
          <p
            class="text-left font-weight-reguler body-2 grey--text text--darken-2 mb-2"
          >
            Valores para Pagamento
          </p>

          <v-tabs
            background-color="grey lighten-3"
            class="elevation-1"
            centered
            grow
            color="var(--vs-azul-primaria)"
            height="45"
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab
              href="#cartao"
              v-if="config.emcChaB2CGatewayPagamento !== 'N'"
              >Cartão de crédito</v-tab
            >

            <v-tab
              href="#boleto"
              v-if="config.emcChaB2CGatewayPagamento !== 'N'"
              >Boleto</v-tab
            >

            <v-tab href="#faturado">Pagamento no balcão</v-tab>

            <v-tab-item value="cartao">
              <v-row no-gutters class="d-flex justify-start align-end pa-0">
                <v-col lg="3" md="12" sm="12">
                  <v-col lg="12" md="12" sm="12" class="pa-0 mb-6">
                    <v-card
                      v-for="(bnd, i) in bandeiras"
                      :key="i"
                      class="d-flex justify-center"
                      elevation="0"
                    >
                      <img
                        :src="bnd.path"
                        v-if="bandeira === bnd.bandeira"
                        :alt="bnd.bandeira"
                        class="pt-6"
                        width="40%"
                      />
                    </v-card>
                  </v-col>

                  <v-col
                    lg="12"
                    md="12"
                    sm="12"
                    class="d-flex justify-start align-end pa-0 mb-10"
                  >
                    <v-row no-gutters class="justify-center">
                      <v-col
                        cols="4"
                        v-for="(bnd, i) in bandeiras"
                        :key="i"
                        class="d-flex justify-center pa-0"
                      >
                        <img
                          :src="bnd.path"
                          :alt="bnd.bandeira"
                          class="pt-6"
                          style="filter: grayscale(100%);"
                          width="60%"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>

                <v-col lg="5" md="12" sm="12">
                  <v-col lg="12" md="12" sm="12">
                    <v-text-field
                      v-model="dadosCartao.numero"
                      label="Número Cartão de Crédito"
                      :rules="rules"
                      hide-details="auto"
                      @input="bandeiraCartao(dadosCartao.numero)"
                      style="width: 350px; font-size: 14px !important"
                      v-mask="mask.creditCard"
                      class="pt-6"
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>

                    <v-text-field
                      v-model="dadosCartao.nome"
                      label="Nome impresso no cartão"
                      :rules="rules"
                      style="width: 350px; font-size: 14px !important;"
                      class="upper"
                      color="var(--vs-azul-secundaria)"
                      @keyup="uppercase"
                    ></v-text-field>

                    <div class="d-flex">
                      <span class="pt-3 pr-4 body-2 grey--text text--darken-2"
                        >Validade</span
                      >
                      <v-select
                        v-model="dadosCartao.mes"
                        label="Mês"
                        :rules="[(v) => !!v || 'Campo obrigatório']"
                        :items="meses"
                        dense
                        class="pr-4"
                        style="max-width: 138px;"
                        color="var(--vs-azul-secundaria)"
                      ></v-select>
                      <v-text-field
                        :min="anoAtual()"
                        v-model="dadosCartao.ano"
                        label="Ano"
                        :rules="[(v) => !!v || 'Campo obrigatório']"
                        type="number"
                        class="pr-4"
                        dense
                        style="max-width: 138px;"
                        color="var(--vs-azul-secundaria)"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </div>

                    <v-text-field
                      v-model="dadosCartao.cvv"
                      label="CVV"
                      :rules="rules"
                      type="number"
                      append-icon="la-credit-card"
                      style="width: 180px; font-size: 14px !important;"
                      class="upper"
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>

                    <div class="d-flex">
                      <span class="pt-3 pr-4 body-2 grey--text text--darken-2"
                        >Parcelar em</span
                      >
                      <v-select
                        v-model="dadosCartao.installments"
                        :rules="rules"
                        :items="parcelas"
                        dense
                        class="pr-4"
                        style="max-width: 100px;"
                        color="var(--vs-azul-secundaria)"
                      ></v-select>
                      <span class="pt-3 pr-4 caption grey--text"
                        >(informe ao lado o nº de parcelas)</span
                      >
                    </div>
                  </v-col>
                </v-col>

                <v-col
                  lg="4"
                  md="12"
                  sm="12"
                  class="d-flex justify-start align-end"
                >
                  <v-row no-gutters>
                    <v-col lg="12" class="grey--text text--darken-2 mt-2 pr-4">
                      <span class="body-2 pl-4 font-weight-bold">Frete</span>

                      <span
                        class="body-2 pl-4 font-weight-bold float-right"
                        v-if="valorFrete === retornoValorFreteNull"
                        ></span
                      >
                      <span
                        class="body-2 pl-4 font-weight-bold float-right"
                        v-else-if="valorFrete == retornoValorFreteZero"
                        >FRETE GRÁTIS</span
                      >
                      <span
                        class="body-2 pl-4 font-weight-bold float-right"
                        v-else-if="valorFrete === true"
                      ></span>
                      <span
                        class="body-2 pl-4 font-weight-bold float-right"
                        v-else
                        >{{ parseFloat(valorFrete).toFixed(2).replace('.', ',') | currency }}</span
                      >
                    </v-col>

                    <v-col lg="12" class="grey--text text--darken-2 mt-2 pr-4">
                      <span
                        class="body-2 pl-4 font-weight-bold"
                        v-if="carrinho.length > 1"
                        >{{ carrinho.length }} produtos</span
                      >
                      <span class="body-2 pl-4 font-weight-bold" v-else
                        >Produto</span
                      >
                      <span
                        class="body-2 pl-4 font-weight-bold float-right"
                        v-if="
                          valorFrete === retornoValorFreteNull ||
                            valorFrete === true
                        "
                        >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
                      >
                      <span
                        class="body-2 pl-4 font-weight-bold float-right"
                        v-else
                        >{{ parseFloat(totalPedidoSemFrete).toFixed(2).replace('.', ',') | currency }}</span
                      >
                    </v-col>

                    <v-col lg="12" class="grey--text text--darken-2 mt-2 pr-4">
                      <span class="body-2 pl-4 font-weight-bold">TOTAL</span>
                      <span class="body-2 pl-4 font-weight-bold float-right">{{
                        parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>

                    <v-col cols="12" class="pa-0 pt-4">
                      <vs-button
                        circle
                        style="min-width: 150px"
                        color="warning"
                        animation-type="scale"
                        @click="pagarCartaoCredito()"
                        class="mb-6"
                      >
                        <i
                          class="las la-check pr-2"
                          style="font-size: 16px !important"
                        ></i>
                        <template>Pagar com cartão de crédito</template>
                      </vs-button>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="boleto">
              <v-row no-gutters class="pa-4">
                <v-col lg="5" md="12" sm="12">
                  <v-row no-gutters class="d-flex">
                    <v-col
                      lg="2"
                      md="4"
                      sm="4"
                      class="d-flex justify-center align-center py-2"
                    >
                      <v-icon size="30" color="white" class="iconBoleto"
                        >la-print</v-icon
                      >
                    </v-col>
                    <v-col
                      lg="10"
                      md="8"
                      sm="8"
                      class="d-flex align-center py-2"
                    >
                      <span class="d-flex caption text-center"
                        >Imprima o boleto e</span
                      >
                      <span class="caption font-weight-bold pl-1 text-center"
                        >pague no banco</span
                      >
                    </v-col>

                    <v-col
                      lg="2"
                      md="4"
                      sm="4"
                      class="d-flex justify-center align-center py-2"
                    >
                      <v-icon size="30" color="white" class="iconBoleto"
                        >la-desktop</v-icon
                      >
                    </v-col>
                    <v-col
                      lg="10"
                      md="8"
                      sm="8"
                      class="d-flex align-center py-2"
                    >
                      <span class="d-flex caption text-center">
                        ou pague pela internet utilizando o código de barras do
                        boleto
                      </span>
                    </v-col>

                    <v-col
                      lg="2"
                      md="4"
                      sm="4"
                      class="d-flex justify-center align-center py-2"
                    >
                      <v-icon size="30" color="white" class="iconBoleto"
                        >la-calendar-check</v-icon
                      >
                    </v-col>
                    <v-col
                      lg="10"
                      md="8"
                      sm="8"
                      class="d-flex align-center py-2"
                    >
                      <span class="d-flex caption text-center"
                        >o prazo de validade do boleto é de</span
                      >
                      <span class="caption font-weight-bold pl-1 text-center"
                        >1 dia útil</span
                      >
                    </v-col>
                  </v-row>
                </v-col>

                <v-col lg="7" md="12" sm="12">
                  <v-icon size="90" class="d-flex">la-barcode</v-icon>
                  <v-row no-gutters>
                    <v-col lg="12" class="text-center pa-0">
                      <span class="body-2 pr-2">Frete</span>

                      <span
                        class="body-2"
                        v-if="valorFrete === retornoValorFreteNull"
                        ></span
                      >
                      <span
                        class="body-2"
                        v-else-if="valorFrete == retornoValorFreteZero"
                        >FRETE GRÁTIS</span
                      >
                      <span
                        class="body-2"
                        v-else-if="valorFrete === true"
                      ></span>
                      <span class="body-2" v-else>{{
                        parseFloat(valorFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>

                    <v-col lg="12" class="text-center pa-0">
                      <span class="body-2 pr-2" v-if="carrinho.length > 1"
                        >{{ carrinho.length }} produtos</span
                      >
                      <span class="body-2 pr-2" v-else>Produto</span>

                      <span
                        class="body-2"
                        v-if="
                          valorFrete === retornoValorFreteNull ||
                            valorFrete === true
                        "
                        >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
                      >
                      <span class="body-2" v-else>{{
                        parseFloat(totalPedidoSemFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>

                    <v-col lg="12" class="text-center pa-0">
                      <span class="body-2 font-weight-bold pr-2">TOTAL</span>
                      <span class="body-2 font-weight-bold">{{
                        parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>
                  </v-row>

                  <v-col lg="12" class="d-flex justify-center">
                    <vs-button
                      circle
                      style="min-width: 150px"
                      color="warning"
                      animation-type="scale"
                      @click="pagarBoleto()"
                    >
                      <i
                        class="las la-check pr-2"
                        style="font-size: 16px !important"
                      ></i>
                      <template>Pagar com boleto</template>
                    </vs-button>
                  </v-col>
                </v-col>
              </v-row>

              <v-row no-gutters class="pa-4">
                <v-col lg="12">
                  <v-card class="mx-auto" max-width="85%" elevation="0">
                    <v-card-text>
                      <div class="caption font-weight-bold">Importante</div>
                      <ul>
                        <li class="caption mb-0">
                          No período de 30 dias, se houver cinco ou mais boletos
                          bancários de um mesmo cliente, não pagos, poderá
                          ocorrer bloqueio temporário desta forma de quitação,
                          por até 30 dias. Nesse período, novas compras poderão
                          ser feitas no site por meio de outras formas de
                          pagamento ou com boleto, pelo Televendas.
                        </li>
                        <li class="caption mb-0">
                          Caso o seu computador tenha um programa anti pop-up,
                          será preciso desativá-lo antes de finalizar sua compra
                          e imprimir o boleto ou pagar pelo internet banking;
                        </li>
                        <li class="caption mb-0">
                          Não faça depósito ou transferência entre contas. O
                          boleto não é enviado pelos Correios. Imprima-o e
                          pague-o no banco ou pela internet;
                        </li>
                        <li class="caption mb-0">
                          Se o boleto não for pago até a data de vencimento, o
                          pedido será automaticamente cancelado;
                        </li>
                        <li class="caption mb-0">
                          O prazo de entrega dos pedidos pagos com boleto
                          bancário começa a contar três dias depois do pagamento
                          do boleto, tempo necessário para que a instituição
                          bancária confirme o pagamento.
                        </li>
                      </ul>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="faturado">
              <v-row no-gutters class="pa-4">
                <v-col lg="5" md="12" sm="12">
                  <v-card-text class="text-center"
                    >Solicitar pagamento no balcão</v-card-text
                  >
                </v-col>

                <v-col lg="7" md="12" sm="12">
                  <v-row no-gutters>
                    <v-col lg="12" class="text-center pa-0">
                      <span class="body-2 pr-2">Frete</span>

                      <span
                        class="body-2"
                        v-if="valorFrete === retornoValorFreteNull"
                        ></span
                      >
                      <span
                        class="body-2"
                        v-else-if="valorFrete == retornoValorFreteZero"
                        >FRETE GRÁTIS</span
                      >
                      <span
                        class="body-2"
                        v-else-if="valorFrete === true"
                      ></span>
                      <span class="body-2" v-else>{{
                        parseFloat(valorFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>

                    <v-col lg="12" class="text-center pa-0">
                      <span class="body-2 pr-2" v-if="carrinho.length > 1"
                        >{{ carrinho.length }} produtos</span
                      >
                      <span class="body-2 pr-2" v-else>Produto</span>

                      <span
                        class="body-2"
                        v-if="
                          valorFrete === retornoValorFreteNull ||
                            valorFrete === true
                        "
                        >{{ parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency }}</span
                      >
                      <span class="body-2" v-else>{{
                        parseFloat(totalPedidoSemFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>

                    <v-col lg="12" class="text-center pa-0">
                      <span class="body-2 font-weight-bold pr-2">TOTAL</span>
                      <span class="body-2 font-weight-bold">{{
                        parseFloat(totalPedidoComFrete).toFixed(2).replace('.', ',') | currency
                      }}</span>
                    </v-col>
                  </v-row>

                  <v-col lg="12" class="d-flex justify-center">
                    <vs-button
                      circle
                      style="min-width: 150px"
                      color="warning"
                      animation-type="scale"
                      @click="solicitarFaturamento()"
                    >
                      <i
                        class="las la-check pr-2"
                        style="font-size: 16px !important"
                      ></i>
                      <template>Finalizar</template>
                    </vs-button>
                  </v-col>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Alert from "../utils/alert";
import CalcFrete from "@/components/CalcularFrete.vue";
import OpcaoEntega from "../components/OpcaoEntrega";

export default {
  directives: {
    mask,
  },
  components: {
    CalcFrete,
    OpcaoEntega,
  },
  data() {
    return {
      opcaoEntregaSelecionada: [],
      rules: [(value) => !!value || "Preenchimento obrigatório."],
      mask: {
        creditCard: "#### #### #### ####",
        fone: "(##) #####-####",
        cnpj: "##.###.###/####-##",
        cep: "#####-###",
      },
      dadosCartao: {
        numero: "",
        nome: "",
        mes: "",
        ano: "",
        bandeira: "",
        cvv: "",
        installments: "",
      },
      meses: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      anos: ["2020", "2021", "2022", "2023"],
      faturado: false,
      dialogDados: false,
      dialogEndereco: false,
      bandeira: "",
      bandeiras: [
        {
          bandeira: "visa",
          path: require(`./../assets/imgBandeiras/visa.png`),
        },
        {
          bandeira: "mastercard",
          path: require(`./../assets/imgBandeiras/master.png`),
        },
        {
          bandeira: "diners",
          path: require(`./../assets/imgBandeiras/diners.png`),
        },
        {
          bandeira: "amex",
          path: require(`./../assets/imgBandeiras/american.png`),
        },
        {
          bandeira: "hipercard",
          path: require(`./../assets/imgBandeiras/hipercard.png`),
        },
        { bandeira: "elo", path: require(`./../assets/imgBandeiras/elo.png`) },
        {
          bandeira: "aura",
          path: require(`./../assets/imgBandeiras/aura.png`),
        },
      ],

      retornoValorFreteNull:
        "Não há uma tabela de valores de frete para sua região! Favor entrar em contato com a concessionária via chat.",
      retornoValorFreteZero: 0.0,
    };
  },
  methods: {
    uppercase() {
      this.dadosCartao.nome = this.dadosCartao.nome.toUpperCase();
    },
    anoAtual() {
      return new Date().getFullYear();
    },
    editarDados(cliente) {
      this.dialogDados = false;
    },
    editarEndereco(cliente) {
      this.dialogEndereco = false;
      this.$store.dispatch("cliente/alterarcliente", cliente);
    },
    procurarDocumento() {
      if (this.usuarioLogado.cliente.cliStrDocumento.length >= 11) {
        this.$store.dispatch("cliente/procurarCliente", {
          cliStrDocumento: this.user.cliStrDocumento,
          empIntCod: this.$route.params.id,
        });
      }
    },
    procurarCEP() {
      if (this.usuarioLogado.busChaCep.length === 9) {
        this.$store.dispatch(
          "cliente/procurarCEPUsuarioLogado",
          this.usuarioLogado.busChaCep.replace(".", "").replace("-", "")
        );
      }
    },
    pagarCartaoCredito() {
      let objPagamentoCartao = {};
      objPagamentoCartao.busuario = this.usuarioLogado;
      objPagamentoCartao.carrinho = this.carrinho;
      objPagamentoCartao.cliente = this.user;
      objPagamentoCartao.tipoPagamento = "C";
      this.dadosCartao.bandeira = this.bandeira;
      objPagamentoCartao.dadosCartao = this.dadosCartao;
      objPagamentoCartao.tipoEntrega = this.tipoEntrega;
      if (
        this.valorFrete === this.retornoValorFreteNull ||
        this.valorFrete === true
      ) {
        objPagamentoCartao.frete = null;
      } else {
        objPagamentoCartao.frete = this.valorFrete;
      }

      if (
        this.dadosCartao.numero === "" ||
        this.dadosCartao.nome === "" ||
        this.dadosCartao.mes === "" ||
        this.dadosCartao.ano === "" ||
        this.dadosCartao.cvv === "" ||
        this.dadosCartao.installments === ""
      ) {
        Alert.warn("", "Os dados do cartão para pagamento são obrigatórios.");
      } else if (this.dadosCartao.ano < this.anoAtual()) {
        Alert.warn("", "A data de vencimento do cartão está inválida.");
      } else if (this.tipoEntrega.length == 0) {
        Alert.warn("", "Você precisa selecionar uma opção de entrega.");
      } else if (this.tipoEntrega === "FRT" && this.valorFrete === true) {
        Alert.warn("", "Você precisa inserir um CEP para calcular o frete.");
      } else {
        this.handleClickLoading("waves");
        this.$store
          .dispatch("pedido/finalizarPedido", objPagamentoCartao)
          .then(
            () => this.hideLoading(),
            this.$router.push({ name: "carrinho" })
          )
          .catch(() => {
            this.hideLoading();
          });
      }
    },
    pagarBoleto() {
      let objPagamentoBoleto = {};
      objPagamentoBoleto.carrinho = this.carrinho;
      objPagamentoBoleto.cliente = this.user;
      objPagamentoBoleto.busuario = this.usuarioLogado;
      objPagamentoBoleto.tipoPagamento = "B";
      objPagamentoBoleto.dadosCartao = null;
      objPagamentoBoleto.tipoEntrega = this.tipoEntrega;
      if (
        this.valorFrete === this.retornoValorFreteNull ||
        this.valorFrete === true
      ) {
        objPagamentoBoleto.frete = null;
      } else {
        objPagamentoBoleto.frete = this.valorFrete;
      }
      if (this.tipoEntrega.length == 0) {
        Alert.warn("", "Você precisa selecionar uma opção de entrega.");
      } else if (this.tipoEntrega === "FRT" && this.valorFrete === true) {
        Alert.warn("", "Você precisa inserir um CEP para calcular o frete.");
      } else {
        this.handleClickLoading("waves");
        this.$store
          .dispatch("pedido/finalizarPedido", objPagamentoBoleto)
          .then(
            () => this.hideLoading(),
            this.$router.push({ name: "carrinho" })
          )
          .catch(() => {
            this.hideLoading();
          });
      }
    },
    solicitarFaturamento() {
      let objSolicitarFaturamento = {};
      objSolicitarFaturamento.carrinho = this.carrinho;
      objSolicitarFaturamento.cliente = this.user;
      objSolicitarFaturamento.tipoPagamento = "F";
      objSolicitarFaturamento.dadosCartao = null;
      objSolicitarFaturamento.busuario = this.usuarioLogado;
      objSolicitarFaturamento.tipoEntrega = this.tipoEntrega;
      if (
        this.valorFrete === this.retornoValorFreteNull ||
        this.valorFrete === true
      ) {
        objSolicitarFaturamento.frete = null;
      } else {
        objSolicitarFaturamento.frete = this.valorFrete;
      }

      if (this.tipoEntrega.length == 0) {
        Alert.warn("", "Você precisa selecionar uma opção de entrega.");
      } else if (this.tipoEntrega === "FRT" && this.valorFrete === true) {
        Alert.warn("", "Você precisa inserir um CEP para calcular o frete.");
      } else {
        this.handleClickLoading("waves");
        this.$store
          .dispatch("pedido/finalizarPedido", objSolicitarFaturamento)
          .then(
            () => this.hideLoading(),
            this.$router.push({ name: "carrinho" })
          )
          .catch(() => {
            this.hideLoading();
          });
      }
    },
    bandeiraCartao(cardnumber) {
      var cardnumber = cardnumber.replace(/[^0-9]+/g, "");

      var cards = {
        visa: /^4[0-9]{12}(?:[0-9]{3})/,
        mastercard: /^5[1-5][0-9]{14}/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
        amex: /^3[47][0-9]{13}/,
        hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
        elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
        aura: /^(5078\d{2})(\d{2})(\d{11})$/,
      };

      for (var flag in cards) {
        if (cards[flag].test(cardnumber)) {
          this.bandeira = flag;
          return this.bandeira;
        }
      }

      return false;
    },
    handleClickLoading(type) {
      this.loading = this.$vs.loading({
        type,
      });
    },
    hideLoading() {
      this.loading.close();
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({
      qtdParcelas: "pedido/qtdParcelas",
      carrinho: "pedido/carrinho",
      tipoEntrega: "pedido/tipoEntrega",
      valorFrete: "pedido/valorFrete",
      totalPedidoComFrete: "pedido/totalPedidoComFrete",
      totalPedidoSemFrete: "pedido/totalPedidoSemFrete",
      user: "cliente/user",
      usuarioLogado: "cliente/usuarioLogado",
      config: "cliente/config",
    }),
    parcelas() {
      let p = [];
      for (let i = 1; i <= this.qtdParcelas; i++) {
        p.push(i + "");
      }
      return p;
    },
  },
};
</script>

<style scoped>
.theme--light.v-select .v-select__selection--comma {
  color: #053b6a;
}

.v-select__selections {
  font-size: 13px;
}

tbody:before,
tbody:after {
  content: none;
}

.iconBoleto {
  background-color: #616161;
  border-radius: 50%;
  width: 45px;
  height: 45px;
}

.bullet {
  list-style-type: circle;
}

.v-slide-group .v-slide-group__prev,
.v-slide-group__next {
  display: none !important;
}
</style>
